{
    "NAME": "Gerätemodal",
    "DeviceModal_AddTitle": "Gerät hinzufügen",
    "DeviceModal_ChangeTitle": "Gerät wechseln",
    "DeviceModal_ViewTitle": "Anzeigegerät",
    "DeviceModal_PromptMessage": "Es liegen ungespeicherte Geräteänderungen vor. Beenden ohne Speichern?",
    "DeviceModal_PromptConfirm": "Ausfahrt",
    "DeviceModal_PromptCancel": "Stornieren",
    "DeviceModal_Tab_General": "Details",
    "DeviceModal_Tab_Advanced": "Fortschrittlich",
    "DeviceModal_Tab_Monitoring": "Überwachung",
    "DeviceModal_Tab_DeviceMembers": "Gerätemitglieder",
    "DeviceModal_Tab_AgentMembers": "Agentenmitglieder",
    "DeviceModal_Tab_DnisMembers": "DNIS",
    "DeviceModal_Tab_LinkedEntities": "Verknüpfte Entitäten",
    "DeviceModal_Loading": "Laden...",
    "DeviceModal_Button_Close": "Schließen",
    "DeviceModal_Button_Cancel": "Stornieren",
    "DeviceModal_Button_Save": "Speichern",
    "DeviceModal_RequestFailed": "Anfrage fehlgeschlagen",
    "DeviceModal_General_IdentifierGuid": "Kennung (GUID)",
    "DeviceModal_General_IdentifierPlaceholder": "[Automatisch zugewiesen]",
    "DeviceModal_General_GuidPendingHelp": "Die Kennung wird nach dem Speichern des Geräts vergeben.",
    "DeviceModal_General_DeviceNumber": "Gerätenummer",
    "DeviceModal_General_DeviceNumberRequired": "Die Gerätenummer wird benötigt.",
    "DeviceModal_General_Description": "Beschreibung",
    "DeviceModal_General_DescriptionRequired": "Eine Beschreibung ist erforderlich.",
    "DeviceModal_General_DeviceType": "Gerätetyp",
    "DeviceModal_General_DeviceTypeRequired": "Gerätetyp erforderlich",
    "DeviceModal_General_Partition": "Partition",
    "DeviceModal_General_PartitionRequired": "Eine Partition ist erforderlich",
    "DeviceModal_General_None": "Keiner",
    "DeviceModal_General_IDOnTelSys": "ID auf dem Telefonieserver",
    "DeviceModal_General_IDOnTelSys_Broadworks": "BroadWorks-Benutzer-ID",
    "DeviceModal_General_IDOnTelSys_Webex": "Webex-Anrufer-ID",
    "DeviceModal_General_IDOnTelSys_MsTeams": "MSTeams-Benutzer-ID",
    "DeviceModal_General_IDOnTelSys_Panasonic": "ID auf dem Telefonieserver",
    "DeviceModal_General_IDOnTelSys_M6": "OID auf dem Telefonserver",
    "DeviceModal_General_IDOnTelSysOwner": "Eigentümergruppen-ID",
    "DeviceModal_General_IDOnTelSysDivision": "Zugehörige Abteilung (Vollständiger Pfad)",
    "DeviceModal_General_InternalExtension": "Interne Wähladresse",
    "DeviceModal_General_TelSysUserID": "Benutzer-ID des Telefonieservers",
    "DeviceModal_General_TelSysUserID_WebexCiscoCommonIdentity": "Cisco Common Identity",
    "DeviceModal_General_TelSysUserID_MsTeamsUpnUrn": "Benutzerprinzipalname (URN)",
    "DeviceModal_General_TelSysPassword": "Telefonie-Server-Passwort",
    "DeviceModal_General_TelSysMonitorPassword": "Monitorpasswort",
    "DeviceModal_General_PrimaryEmail": "Primäre E-Mail-Adresse",
    "DeviceModal_General_UpdateExistingItems": "Aktualisieren Sie vorhandene Einträge, falls Duplikate gefunden werden.",
    "DeviceModal_Monitoring_OverrideMonitoring": "Überwachung außer Kraft setzen (nicht überwacht)",
    "DeviceModal_Monitoring_DisableRTMonitoring": "Echtzeitüberwachung deaktivieren",
    "DeviceModal_Members_DeviceNumber": "Gerätenummer",
    "DeviceModal_Members_Description": "Beschreibung",
    "DeviceModal_Members_AgentNumber": "Agentennummer",
    "DeviceModal_Members_Actions": "Aktionen",
    "DeviceModal_Members_Add": "Mitglied hinzufügen",
    "DeviceModal_Members_AddHotkey": "Mitglied hinzufügen (Strg+Eingabe)",
    "DeviceModal_Members_Remove": "Mitglied entfernen",
    "DeviceModal_Members_Search": "Mitglieder suchen",
    "DeviceModal_Members_NoDeviceMembers": "Keine Gerätemitglieder",
    "DeviceModal_Members_NoAgentMembers": "Keine Agentenmitglieder",
    "DeviceModal_Members_DnisNumber": "DNIS-Nummer",
    "DeviceModal_Members_AddDnis": "DNIS hinzufügen",
    "DeviceModal_Members_AddDnisHotkey": "DNIS hinzufügen (Strg+Eingabe)",
    "DeviceModal_Members_NoDnisMembers": "Keine DNIS-Zugehörigkeiten",
    "DeviceModal_LinkedEntities_Loading": "Verknüpfte Entitäten werden geladen…",
    "DeviceModal_LinkedEntities_Empty": "Keiner",
    "DeviceModal_LinkedEntities_Section_Groups": "Gruppenmitgliedschaften",
    "DeviceModal_LinkedEntities_Section_Users": "Zugehörige Benutzer",
    "DeviceModal_LinkedEntities_Column_GroupId": "Gruppe",
    "DeviceModal_LinkedEntities_Column_Description": "Beschreibung",
    "DeviceModal_LinkedEntities_Column_UserId": "Benutzer"
}